import { Create, SimpleForm, TextInput } from "react-admin";

export const SpecialtyCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="code" />
      <TextInput source="name" />
      <TextInput source="comment" />
    </SimpleForm>
  </Create>
);
